import type { ComponentData } from '../lib/types/aem';
import { useAemData as _useAemData, type UseAemDataFn } from '@dh-io-owpi/shared/src/plugins/aemData';

// creates a typed inject function with the ComponentData
export const useAemData = <UseAemDataFn<ComponentData>>_useAemData;
